<div id="repairMainSpinner">
    <div *ngIf="!loaded">
        <app-spinner></app-spinner>
    </div>
    <div [hidden]="!loaded">
        <div class="bs-callout bs-callout-info" id="callout-helper-context-color-specificity"
            *ngIf="submissionStatus==='Complete'">
            <h4>{{pageSubHeading}}</h4>
            <span [innerHTML]="successfulSubmissionText"></span>
        </div>

        <div class="bs-callout bs-callout-error" id="callout-helper-context-color-specificity"
            *ngIf="submissionStatus==='Failed'">
            <span [innerHTML]="failedSubmissionText"></span>
        </div>


        <div *ngIf="submissionStatus !=='Complete'">
            <table class="appointments__table table table-striped">
                <caption class="appointments__caption sr-only"> {{appointment.startTime | date:'LLLL'}}
                </caption>
                <thead class="sr-only">
                    <tr>
                        <th>Date</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="appointment">
                        <td class="appointment__dates">
                            <p class="appointment__day">{{appointment.startTime | date:'EEE'}}</p>
                            <p class="appointment__month">{{appointment.startTime | date:'dd'}}
                                {{appointment.startTime | date:'MMM'}}</p>
                            <p class="appointment__time">{{appointment.startTime |
                                date:'HH'}}:{{appointment.startTime | date:'mm'}} {{appointment.startTime |
                                date:'a'}}</p>
                        </td>
                        <td>
                            <h3 class="appointment__heading" *ngFor="let sor of appointment.repairDescription">
                                {{sor.description}}
                            </h3>
                            <p class="appointment__description">{{appointment.contractorName}} will be attending
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="well bs-component">
                <form [formGroup]="reCallForm" id="reCallForm" name="reCallForm" novalidate class="form-horizontal">
                    <fieldset>
                        <legend>{{formText}}</legend>
                        <div class="form-group"
                            [class.has-error]="reCallForm.get('feedback')?.touched && reCallForm.get('feedback')?.invalid">
                            <label for="feedback" class="col-sm-2 control-label">Feedback</label>
                            <div class="col-sm-10 has-feedback">
                                <textarea class="form-control" rows="10" maxlength="2000" id="feedback" name="feedback"
                                    formControlName="feedback" [value]="form.feedback" required></textarea>
                                <span
                                    [hidden]="!(reCallForm.get('feedback')?.touched && reCallForm.get('feedback')?.invalid)"
                                    class="help-block">
                                    <div role="alert">
                                        <div *ngIf="reCallForm.get('feedback')?.errors?.['required']">Please provide
                                            details on your feedback</div>
                                        <div *ngIf="reCallForm.get('feedback')?.errors?.['maxlength']">Please provide
                                            up to 2000 characters maximum</div>
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="col-sm-10 col-sm-offset-2">
                                <a href="/repairs" class="btn btn-secondary">Back</a>&nbsp;
                                <button (click)="onSubmit($event)" class="btn btn-primary" style="position:relative;">
                                    <span>Send</span>
                                    <span></span>
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</div>